import { Component, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { AddUsersIssuesService } from '../../../account/account-settings/add-users-modal/add-users-issues.service';

@Component({
    selector: 'pp-fleet-sharing-error-box',
    templateUrl: './fleet-sharing-error-box.component.html',
    styleUrls: ['./fleet-sharing-error-box.component.scss'],
    standalone: false
})
export class FleetSharingErrorBoxComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  errorMessages: string[] = [];
  EIconPath = EIconPath;

  constructor(private createAccountUserModalIssuesService: AddUsersIssuesService) {
    this.subscribeToErrorChange();

    this.handleErrors();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  handleErrors(): void {
    this.errorMessages = this.createAccountUserModalIssuesService.getErrorMessages();
  }

  private subscribeToErrorChange() {
    this.createAccountUserModalIssuesService.errorChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe((errors) => {
        this.handleErrors();
      });
  }
}
